<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="writeOffShow"
            >核销</el-button
          >
        </div>
        <div class="header-right">
          <div>
            <el-input
              type="text"
              size="small"
              v-model="cardId"
              placeholder="卡号"
            ></el-input>
          </div>
          <div>
            <el-input
              type="text"
              size="small"
              v-model="phone"
              placeholder="手机号"
            ></el-input>
          </div>
          <el-button type="primary" size="small" @click="getPageData"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="recordList" style="width: 100%;">
            <el-table-column label="权益卡名称" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.cardName || "卡片名称" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="卡号" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.cardNo }}</div>
              </template>
            </el-table-column>
            <el-table-column label="手机号" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="门店" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.shopName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="核销人" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.workerPhone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="核销时间" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.createTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="核销次数" align="center">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.times || 1 }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div
      class="popup write-off"
      :class="{
        show: showWriteOffPop,
      }"
      style="z-index:2000"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>核销</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="showWriteOffPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            label-width="128px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="核销码" prop="cardName">
              <el-input
                type="text"
                placeholder="扫入或输入核销码"
                v-model="writeOffNo"
                size="small"
                ref="noinput"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input-number
                v-model="writeOffTimes"
                :min="1"
                label="请输入核销次数"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="writeOffConfirm" :loading="isUpload"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTimeCardRecordList,
  verifyRecord,
  saveTimeMemberCard,
} from "@/api/index.js";
import { createScannerInput } from "@/utils/scannerInput";
export default {
  data() {
    return {
      cardId: "",
      phone: "",
      statusObj: {
        1: {
          text: "使用中",
          class: "on",
          btnText: "停用",
          btnType: "danger",
        },
        2: {
          text: "失效",
          class: "off",
          btnText: "启用",
          btnType: "success",
        },
        3: {
          text: "过期",
          class: "expire",
        },
      },
      recordList: [],
      showWriteOffPop: false,
      isEnd: false,
      writeOffNo: "",
      writeOffTimes: 1,
      isUpload: false,
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
    };
  },
  watch: {
    showWriteOffPop(val) {
      if (!val) {
        this.writeOffNo = "";
        this.writeOffTimes = 1;
      }
    },
  },
  mounted() {
    this.writeOffScanner = createScannerInput({
      getValue: () => this.writeOffNo,
      setValue: (value) => {
        this.writeOffNo = value;
      },
      getInput: () => {
        if (this.$refs.noinput && this.$refs.noinput.$refs) {
          return this.$refs.noinput.$refs.input;
        }
        return null;
      },
      onEnter: () => {},
      readonlyOnScan: true,
    });
    document.onkeydown = this.writeOffScanner.handleKeydown;
    if (this.$route.query.id) {
      this.cardId = this.$route.query.id;
    }
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getTimeCardRecordList();
    },
    getTimeCardRecordList() {
      getTimeCardRecordList({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        phone: this.phone,
        cardNo: this.cardId,
      }).then((res) => {
        if (res.code == 1) {
          this.recordList = res.data.list;
        }
        if (res.code == -1) {
          this.recordList = [];
        }
        this.pageCount = res.data.totalCount;
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getTimeCardRecordList();
    },
    writeOffShow() {
      this.showWriteOffPop = true;
      setTimeout(() => {
        this.$refs.noinput.focus();
      }, 500);
    },
    writeOffConfirm() {
      verifyRecord({
        cardNo: this.writeOffNo,
        times: this.writeOffTimes,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "核销成功",
            type: "success",
            duration: 1000,
          });
          this.showWriteOffPop = false;
          this.getTimeCardRecordList();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    saveTimeMemberCard(item, index) {
      saveTimeMemberCard({
        phone: item.phone,
        timeCardId: item.timeCardId,
        timeMemberCardId: item.timeMemberCardId,
        status: item.status == 1 ? 2 : 1,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: `${item.status == 1 ? "停用" : "启用"}成功`,
            type: "success",
            duration: 1000,
          });
          this.recordList[index].status = item.status == 1 ? 2 : 1;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
        this.isUpload = false;
        this.vipSendCardPop = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    & > div {
      margin-right: 20px;
    }
  }
  .el-link + .el-button {
    margin-left: 10px;
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.expire {
        color: #ffaa00;
      }
      &.on {
        color: #7abd54;
      }
      &.off {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.popup {
  &.write-off {
    .popup-container {
      width: 400px;
      padding: 20px;
      .el-input {
        width: 220px;
      }
      .hav-tips {
        margin-bottom: 0;
      }
      .tips {
        display: flex;
        line-height: 30px;
        color: #ccc;
      }
      .el-button {
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>
